import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectCustomerProfile } from 'src/store/selectors/customerProfile'
import {
  selectCMAFlowInitialStep,
  selectPreviousREA
} from 'src/store/selectors/home/cma'
import { selectCurrentAVM } from 'src/store/selectors/home/avm'
import { REA } from 'src/constants/agent_types'

const CMASectionContainer = compose(
  connect(state => {
    const profile = selectCustomerProfile(state) || {}

    return {
      initialStep: selectCMAFlowInitialStep(state),
      avm: selectCurrentAVM(state),
      previousREA: profile.type === REA ? null : selectPreviousREA(state)
    }
  })
)

export default CMASectionContainer
